<template>
  <div>
    <mt-editor
      :typeOfEditor="typeOfEditor"
      :editable="editable"
      v-model="noteContent"
      @input="handleInputNoteContent"
      @image-added="handleImageAdded"
      @save="handleSave"
      ref="MtEditor"
      v-if="!isOldChrome"
    >
      <template #note-drag-bar>
        <div class="note-drag-bar drag-el">
          <div class="status-bar">
            <div class="status-bar--content status-bar--info">
              <!---->
              <!---->
              <span class="text" v-if="ms_isNoteFetched">
                <span class="text-msg">
                  <template v-if="ms_isNoteSaved">
                    {{ ms_isSaveImmediately ? '' : '自动' }}保存成功
                  </template>
                  <template v-if="ms_isNoteSaving">
                    {{ ms_isSaveImmediately ? '' : '自动' }}保存中
                  </template>
                  <template v-if="!ms_isNoteSaving && !ms_isNoteSaved">
                    {{ '笔记内容加载完成' }}
                  </template>
                </span>
                <span v-show="ms_isNoteSaved">
                  {{ ms_dateNoteSaved }}
                </span>
              </span>
            </div>
          </div>
          <!-- <div class="operation-btns">
          <a title="我的笔记" target="_blank" href="/notes" class="close-btn">
            <i class="bili-note-iconfont iconicon_notebook">n</i>
          </a>
          <span class="column-line"></span>
          <a
            title="问卷调查"
            target="_blank"
            href="//www.bilibili.com/blackboard/activity-h9ASMqpFw.html"
            class="close-btn"
          >
            <i class="bili-note-iconfont iconiconfont_icon_suggest">?</i>
          </a>
          <div class="close-btn" @click.prevent="closeNote">
            <i class="bili-note-iconfont iconiconfont_icon_close">c</i>
          </div>
        </div> -->
        </div>
      </template>
    </mt-editor>
    <p v-if="isOldChrome">
      {{ '当前浏览器不支持笔记编辑功能，请您升级浏览器后再尝试。' }}
    </p>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import { NoteContentModelMixin } from '@/mixins/Note/Content/model';

import { getIsOldChrome } from '@/utils/browser';

export default {
  name: 'note-content',

  mixins: [NoteContentModelMixin],

  components: {
    'mt-editor': () => import('@/components/MtEditor.vue'),
  },

  props: {
    value: {
      type: String,
      default: () => '',
    },

    typeOfEditor: {
      type: String,
      default: () => 'EXERCISE_NOTE',
    },

    editable: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      prevValue: '',

      isOldChrome: getIsOldChrome(),
    };
  },

  computed: {
    ...mapState('Mixins/Note', {
      ms_isNoteFetched: 'isNoteFetched',
      ms_isNoteSaving: 'isNoteSaving',
      ms_isNoteSaved: 'isNoteSaved',
      ms_dateNoteSaved: 'dateNoteSaved',
      ms_isSaveImmediately: 'isSaveImmediately',
    }),
  },

  watch: {
    value(v) {
      if (this.prevValue !== v) {
        this.prevValue = v;
        this.noteContent = v;
      }
    },
  },

  methods: {
    handleInputNoteContent() {
      this.prevValue = this.noteContent;
      this.$emit('input', this.noteContent);
    },

    handleImageAdded({ allPromiseUploadImg }) {
      this.$emit('image-added', { allPromiseUploadImg });
    },

    handleSave({ isSaveImmediately }) {
      this.$emit('save', { isSaveImmediately });
    },
  },

  created() {
    if (this.value) {
      this.prevValue = this.value;
      this.noteContent = this.value;
    }
  },
};
</script>
<style lang="scss" scoped></style>
